import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/HomeView.vue";
import LoginView from "@/views/LoginView.vue";
import TiempoRealView from "@/views/TiempoRealView.vue";
import HistoricoView from "@/views/HistoricoView.vue";
import AccumulativeView from "@/views/AccumulativeView.vue";
import FabricacionView from "@/views/FabricacionView.vue";
import AlarmsPage from "@/views/AlarmsView.vue";
import NotificationsView from "@/views/NotificationsView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Home",
          content:
            "Página principal de la app para " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/now",
    name: "tiempoReal",
    component: TiempoRealView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Ahora",
          content:
            "Página de tiempo real de la app para " +
            process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  ,
  {
    path: "/alarms",
    name: "alarms",
    component: AlarmsPage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Alarmas",
          content: "Página de alarmas de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/history",
    name: "historico",
    component: HistoricoView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Histórico",
          content:
            "Página de históricos de la app para " +
            process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/accumulative",
    name: "accumulative",
    component: AccumulativeView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Acumulado",
          content:
            "Página de acumulados de la app para " +
            process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/fabrication",
    name: "fabrication",
    component: FabricacionView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Fabricación",
          content:
            "Página de fabricacion de la app para " +
            process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Login",
          content:
            "Página de Login de la app GMAO de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: NotificationsView,
    meta: {
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Notifications",
          content:
            "Página de notificaciones de la app para " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  const pageTitle = to.meta.title;
  if (pageTitle) {
    document.title = `${pageTitle} - ${to.meta.metaTags[0].name}`;
  }
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: "login" });
  } else {
    if (to.path == "/users") {
      // evitamos que se entre a la gestión de usuarios si no es admin o avanzado
      let is_admin = JSON.parse(localStorage.getItem("user"));
      if (is_admin) {
        is_admin =
          is_admin.role_name == "admin" || is_admin.role_name == "avanzado";
        if (is_admin) next();
        else {
          router.push({ name: "home" });
          console.log("no puede entrar a la gestion de usuarios");
        }
      }
    }
    if (loggedIn ? to.path !== "/login" : true) next();
  }
});
export default router;
